/**
 * « Aujourd'hui » au sens de l'entrepôt : la date à Bruxelles, AAAA-MM-JJ —
 * jumeau de `backend/src/lib/dates.js` (le front ne peut pas importer le back).
 * `new Date().toISOString().slice(0, 10)` donne la date UTC : entre minuit et 2 h
 * (heure d'été), elle vaut encore la veille.
 */
// Format construit pièce par pièce : on ne dépend pas du format « court » par
// défaut d'une locale. Créé une seule fois.
const PARTIES_BRUXELLES = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/Brussels', year: 'numeric', month: '2-digit', day: '2-digit',
});
export function aujourdhuiBruxelles(date = new Date()) {
  const p = Object.fromEntries(PARTIES_BRUXELLES.formatToParts(date).map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day}`;
}
